import React from "react";
import Card3 from "../Card/blog-header";

const Articles2 = ({ articles }) => {
  const leftArticles = articles.slice(0, articles.length / 2);
  const rightArticles = articles.slice(4);

  return (
    <div className="flex">
      <div>
        <div>
          {rightArticles.map((article, i) => {
            return <Card3 article={article} key={`article__${article.slug}`} />;
          })}
        </div>
      </div>
    </div>
  );
};

export default Articles2;
